import '../styles/LinkTracker.css';
import { useLinkTracker } from '../hooks/useLinkTracker';

export const LinkTracker = (props) => {
    const {
        generateOnClick,
    } = useLinkTracker();

    return (
        <span
            className={'like-link'}
            role={'link'}
            onClick={generateOnClick(props.url, props.trackerKey, props.accessId, props.onUpdateRecord, props.timeOfMount)}
        >
            {props.linkText}
        </span>
    );
};